"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = TextIndentIncrease;

var _TextIndentIncrease = require("@adobe/react-spectrum-workflow/dist/TextIndentIncrease.js");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function TextIndentIncrease(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_TextIndentIncrease.A4uTextIndentIncrease, null));
}